import { LAST_VIEWED_LS_KEY, RELEASES } from "./constants";

export const hasSeenLatestReleaseNotes = () =>
  localStorage.getItem(LAST_VIEWED_LS_KEY) === RELEASES[0].version;
